var map = {
	"./celery.png": 4263,
	"./chilli.png": 5416,
	"./crustaceans.png": 2671,
	"./dairy.png": 2058,
	"./egg.png": 7533,
	"./fish.png": 6436,
	"./gluten.png": 8987,
	"./lupins.png": 5970,
	"./molluscs.png": 3142,
	"./mustard.png": 9477,
	"./nuts.png": 6698,
	"./peanut.png": 6169,
	"./sesame.png": 9081,
	"./soya.png": 1733,
	"./sulphite.png": 1265,
	"./vegan.png": 3886,
	"./vegetarian.png": 1427
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 1);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 5322;
module.exports = webpackAsyncContext;